import { toast } from 'react-toastify'; // Import toast for notifications
import routes from '../../../../../Routes/routes'; // App routes
import { CreateCafeteria } from "../../../../../reduxToolkit/FoodieCafeteria/CafeteriaApi"; // API call to create cafeteria
import { useEffect } from "react";
import {DEFAULT_LATITUDE, DEFAULT_LONGITUDE, errorMsg} from "../../../../../Apis/functions";
import {useLocation, useNavigate} from "react-router-dom";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

// Custom hook that manages cafeteria creation logic
const CreateCafeteriaApp = ({
                                t,                    // i18n translation function
                                item,                 // Cafeteria form data (model)
                                setItem,
                                navigate,             // React router navigation
                                dispatch,             // Redux dispatch function
                                deviceSelectedList,   // List of selected devices for the cafeteria
                                toRegisterDays,       // Function to register selected days
                                setShowOverlay,       // Callback to toggle overlay visibility
                                setFirstClickOnMap    // Callback to control map interaction
                            }) => {
    const location = useLocation();
    let { state } = location;
    /**
     * useEffect runs once on mount to show overlay and prevent map click.
     */
    useEffect(() => {
        setShowOverlay(true);        // Show loading overlay
        setFirstClickOnMap(false);   // Reset map click state
        setItem({...item, latitude: DEFAULT_LATITUDE, longitude: DEFAULT_LONGITUDE })
    }, []);

    /**
     * Handles the creation of a new cafeteria.
     */
    const handleCreate = () => {
        // Prepare data to send to API
        let aux = {
            ...item,
            deviceIds: deviceSelectedList.map(e => e.id) // Attach selected devices
        };
        aux = toRegisterDays(aux); // Convert selected days to model structure

        // Transform the object to API request format
        let body = aux.toRegister();

        // Dispatch create action to Redux
        dispatch(CreateCafeteria(body)).then(({ payload: { data: { data, code, message } } }) => {
            if (data?.id) {
                // If cafeteria is created successfully
                navigate(routes.foodie.list); // Navigate to cafeteria list
                toast.success(t('has_been_created_successfully')); // Show success notification
            } else errorMsg(code);
        });
    };

    const goBack = () => {
        if(state?.backUrl){
            navigate(state.backUrl.pathname, {
                state: {...state?.backUrl?.state}
            });
        } else {
            navigate(routes.foodie.list)
        }
    }

    // Expose the create handler
    return {
        handleCreate,
        goBack
    };
};

export default CreateCafeteriaApp;
